<div class="col-md-12 mb-30" [hidden]="Selected_Record_Schedules.id>0">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Behfa Equipment Management</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Letter Number</label>
          <input [(ngModel)]="Filter_Letter" name="Filter_Letter" type="number" class="form-control"
            placeholder="Type here to search...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_Schedules()" class="btn btn-info"
            style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>

          <button *ngIf="Procssing" type="button" class="btn btn-info" style="margin-right: 5px;"> Please wait... <i
              class="fa fa-spin fa-spinner"></i> </button>

        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Decree Number</th>
              <th>Letter Number</th>
              <th>Customer Name</th>
              <th>Date</th>
              <th>Time</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Schedules">
              <td>{{DataList_Schedules.indexOf(item)+1}}</td>
              <td>{{item.code2}}</td>
              <td>{{item.code}}</td>
              <td>{{item.customerName}}</td>
              <td>{{item.persianDate}}</td>
              <td>{{item.clock}}</td>
              <td>
                <button ype="button" (click)="set_Selected_Record_Schedules(item)" class="btn btn-info">View
                  Details</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="col-md-12 mb-30" *ngIf="Selected_Record_Schedules.id>0">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Assignment Details</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Decree Number</label>
          <input [(ngModel)]="Selected_Record_Schedules.code2" disabled name="code2" class="form-control"
            placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Letter Number</label>
          <input [(ngModel)]="Selected_Record_Schedules.code" disabled name="code" class="form-control"
            placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Customer Name</label>
          <input [(ngModel)]="Selected_Record_Schedules.customerName" disabled name="customerName" class="form-control"
            placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Date</label>
          <input [(ngModel)]="Selected_Record_Schedules.persianDate" disabled name="persianDate" class="form-control"
            placeholder="Type here to search...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Processing_Detail" type="button" style="margin-right: 5px;"
            (click)="openModal_DeviceBehfa(templateDeviceBehfa)" class="btn btn-info left"> Add Behfa Equipment <i
              class="fa fa-building"></i> </button>
          <a target="_blank" style="margin-right: 5px;" href="{{BaseUrl2}}{{Selected_Record_Schedules.id}}"
            class="btn btn-success"><i class="fa fa-file-pdf-o"></i> PDF </a>
          <button *ngIf="!Processing_Detail" style="margin-right: 5px;" (click)="back_Selected_Record_Schedules()"
            type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>

          <button *ngIf="Processing_Detail" type="button" class="btn btn-info" style="margin-right: 5px;"> Please wait
            ... <i class="fa fa-spin fa-spinner"></i> </button>
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>System ID</th>
              <th>Description</th>
              <th>Manufacturer</th>
              <th>Model</th>
              <th>Code BEHFA</th>
              <th>User</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of DataList_Mission_Device">


              <tr>
                <td rowspan="2">{{DataList_Mission_Device.indexOf(item)+1}}</td>
                <td>{{item.code}}</td>
                <td class="EnglishClm">{{item.description}}</td>
                <td class="EnglishClm">{{item.manufacturer}}</td>
                <td class="EnglishClm">{{item.model}}</td>
                <td class="EnglishClm">{{item.codeBEHFA}}</td>
                <td class="EnglishClm">{{item.username}}</td>
                <td class="EnglishClm">{{item.persianDate}}</td>
                <td>
                  <a *ngIf="!item.del" style="cursor: pointer;" class="dropdown-item"
                    (click)="openModal(template,item)"><i class="fa fa-remove"></i> Delete </a>
                  <p *ngIf="item.del" style="color: red; font-weight: 600;">Deleted</p>
                </td>
              </tr>
              <tr>
                <td><b>Change Description</b></td>
                <td colspan="8">
                  {{item.dsc}}
                </td>
              </tr>

            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Confirm Equipment Removal from Assignment '{{Selected_Mission_Device.codeBEHFA}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">Description</label>
        <input [(ngModel)]="DeviceBehfa_Delete_Dsc" name="DeviceBehfa_Delete_Dsc" type="text" class="form-control"
          placeholder="Type here...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" [disabled]="!DeviceBehfa_Delete_Dsc"
      (click)="Delete(Selected_Mission_Device)"> Delete <i class="fa fa-remove"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">Close</button>
  </div>
</ng-template>


<ng-template #templateDeviceBehfa>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Behfa Equipment List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_DeviceBehfa.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <app-DeviceBehfaActiveList [inner_PersianDate]="Selected_Record_Schedules.persianDate"
      [inner_SeletedDeviceBehfa]="DataList_Mission_Device_NoneDelete"
      (seleted_DeviceBehfa_Interface)="Set_Selected_DeviceBehfa_Record($event)">

    </app-DeviceBehfaActiveList>
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">Description</label>
        <input [(ngModel)]="DeviceBehfa_Delete_Dsc" name="DeviceBehfa_Delete_Dsc" type="text" class="form-control"
          placeholder="Type here...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_DeviceBehfa.hide()">Close</button>
  </div>
</ng-template>
